import React from "react";

import { useState, useEffect } from "react";
import MockPagination from "./Pagination";
import MockNavigation from "./MockNavigation";
import KeyBoardCheckPage from "./KeyboardCheckPage";
import HeadphoneCheckPage from "./HeadphonePage";
import MicrophoneCheckPage from "./MicrophonePage";
import TestIntroductionPage from "./TestIntroduction";
import SpeakingInstructionPage from "./SpeakingInstruction";
import FullSectionPage from "./FullSectionTable";
import SectionPage from "./SectionPage";
import PersonalIntroductionPage from "./PersonalIntroductionPage";
import ReadAloudPage from "./Speaking/ReadAloudPage";
import RepeatSentencePage from "./Speaking/RepeatSentencePage";
import DescribeImageMockPage from "./Speaking/DescribeImageMock";
import ReTellMockPage from "./Speaking/ReTellMock";
import ShortAnswersMockPage from "./Speaking/ShortAnswersMock";
import SummarizeMockPage from "./Writing/SummarizeMock";
import WriteEssayMockPage from "./Writing/WriteEssay";
import MultipleTypeSingleMockPage from "./Reading/MultipleTypeSingleMock";
import MultipleTypeDoubleMockPage from "./Reading/MultipleDoubleTypleMock";
import ReArrangeSentenceMockPage from "./Reading/ReArrangeMock";
import ReadingFillInTheBlanksMockPage from "./Reading/ReadingFillInTheBlanksMock";
import FillInTheBlanksReadingAndWritingMockPage from "./Reading/FillInTheBlanksReadingAndWritingMock";
import SummarizeSpokenTestMockPage from "./Listening/SummarizeSpokenTextMock";
import MCQSingleAnswerMockPage from "./Listening/MCQSingleAnswerMock";
import MCQMultipleAnswerMockPage from "./Listening/MCQMultipleAnswerMock";
import FillInTheBlanksMockPage from "./Listening/FillInTheBlanksMock";
import HighlightCorrectSummaryMockPage from "./Listening/HighlightCorrectSummaryMock";
import SelectMissingWordsMockPage from "./Listening/SelectMissingWordMock";
import HighlightIncorrectWordMockPage from "./Listening/HighlightIncorrectWordMock";
import WriteFromDictationMockPage from "./Listening/WriteFromDictationMock";
import Notification from "../QuestionPage/Notification";
import ConfirmDialog from "./PopUp";
import Loading from "./SpinnerLoading"; // Import the loading component
import Timer from "./Timer";

// function ConfirmDialog({ message, onConfirm, onCancel }) {
//   return (
//     <div
//       style={{
//         position: "fixed",
//         top: "50%",
//         left: "50%",
//         transform: "translate(-50%, -50%)",
//         backgroundColor: "white",
//         border: "1px solid #ccc",
//         padding: "20px",
//         zIndex: 1000,
//       }}
//     >
//       <p>{message}</p>
//       <button onClick={onConfirm}>Yes</button>
//       <button onClick={onCancel}>No</button>
//     </div>
//   );
// }

// Page Html
export default function FullMockTestPage() {
  const [MockData, setMockData] = useState({
    data: [],
  });
  const [userInputs, setUserInputs] = useState({});

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [notificationType, setNotificationType] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [nextPage, setNextPage] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // New state for loading

  useEffect(() => {
    const fetchMockData = async () => {
      try {
        const response = await fetch("/api/mockquestions/all", {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();

          setMockData({
            data: data,
          });

          console.log("Data:", data);
        } else {
          console.error(
            "Failed to fetch MockTest data. Status:",
            response.status
          );
        }
      } catch (error) {
        console.error("Error fetching MockTest data:", error);
      } finally {
        setLoading(false); // Set loading to false regardless of success or failure
      }
    };

    fetchMockData();
  }, []);

  console.log("Mock Data:", MockData.data.AnswershortQuestion);

  const handleInputChange = (questionType, questionIndex, answer) => {
    setUserInputs((prevInputs) => ({
      ...prevInputs,
      [questionType]: {
        ...prevInputs[questionType],
        [questionIndex]: answer,
      },
    }));
  };

  console.log("User Input", userInputs);

  const splitData = (data, size) => {
    const chunks = [];
    for (let i = 0; i < data.length; i += size) {
      chunks.push(data.slice(i, i + size));
    }
    return chunks;
  };

  const handleSubmit = async () => {
    const payload = { userInputs, MockData }; // Assuming userInputs and MockData are defined
    const payloadString = JSON.stringify(payload);
    const maxChunkSize = 50000; // Reduce the chunk size further (e.g., 50KB)
    const chunks = splitData(payloadString, maxChunkSize);

    console.log(`Total chunks: ${chunks.length}`);

    try {
      for (const [index, chunk] of chunks.entries()) {
        console.log(`Sending chunk ${index + 1} of ${chunks.length}`);
        const response = await fetch("/api/save-fullmocktestdata", {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ chunk, index, totalChunks: chunks.length }),
        });
        if (!response.ok) {
          console.error("Failed to submit data chunk. Status:", response.status);
          throw new Error(`Failed to submit data chunk. Status: ${response.status}`);
        }
      }
      console.log("Data submitted successfully");
      setMessage("Mock data saved successfully!");
      setNotificationType("success");
      setShowNotification(true); // Show notification

      setTimeout(() => {
        setLoading(false);
        setSubmitted(true);
      }, 2000);
    } catch (error) {
      console.error("Error submitting data:", error);
      setMessage("Failed to save MockTest.");
      setNotificationType("error");
      setShowNotification(true); // Show error notification
      setLoading(false);
      setSubmitted(false);
    }
  };

  const handleCloseNotification = () => {
    setShowNotification(false);
  };

  // Empty dependency array to fetch data only once on mount
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = 66;
  const handleNext = () => {
    setShowConfirmDialog(true);
    setNextPage((prevPage) => prevPage + 1);
  };

  const handleConfirm = () => {
    setShowConfirmDialog(false);
    setIsLoading(true); // Start loading

    // Set timeout to simulate loading delay
    setTimeout(() => {
      setIsLoading(false); // End loading
      setCurrentPage(nextPage); // Proceed to the next page
    }, 100);
  };

  const handleCancel = () => {
    setShowConfirmDialog(false); // Hide the confirmation dialog
  };

  const handlePrevious = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const disableNext = currentPage === totalPages;
  const disablePrevious = currentPage === 1;

  const renderPage = () => {
    // Check the range of pages 9 to 11 first
    if (currentPage >= 9 && currentPage <= 14) {
      const questionIndex = currentPage - 9;
      const currentQuestion = MockData.data.Readaloud[questionIndex];
      return (
        <ReadAloudPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("Readaloud", questionIndex, answer)
          }
          questionNumber={questionIndex + 1}
        />
      );
    }
    if (currentPage >= 15 && currentPage <= 26) {
      const questionIndex = currentPage - 15;
      const currentQuestion = MockData.data.RepeatSentence[questionIndex];
      return (
        <RepeatSentencePage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("RepeatSentence", questionIndex, answer)
          }
          questionNumber={questionIndex + 7} // Pass question number
        />
      );
    }
    if (currentPage >= 27 && currentPage <= 29) {
      const questionIndex = currentPage - 27;
      const currentQuestion = MockData.data.DescribeImage[questionIndex];
      return (
        <DescribeImageMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("DescribeImage", questionIndex, answer)
          }
          questionNumber={questionIndex + 19}
        />
      );
    }
    if (currentPage >= 30 && currentPage <= 31) {
      const questionIndex = currentPage - 30;
      const currentQuestion = MockData.data.RetellLecture[questionIndex];
      return (
        <ReTellMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("ReTellLecture", questionIndex, answer)
          }
          questionNumber={questionIndex + 22}
        />
      );
    }
    if (currentPage >= 32 && currentPage <= 36) {
      const questionIndex = currentPage - 32;
      const currentQuestion = MockData.data.AnswershortQuestion[questionIndex];
      return (
        <ShortAnswersMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("AnswershortQuestion", questionIndex, answer)
          }
          questionNumber={questionIndex + 24}
        />
      );
    }
    if (currentPage >= 37 && currentPage <= 38) {
      const questionIndex = currentPage - 37;
      const currentQuestion = MockData.data.SummarizeText[questionIndex];
      return (
        <SummarizeMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("SummarizeText", questionIndex, answer)
          }
          questionNumber={questionIndex + 29}
        />
      );
    }
    if (currentPage >= 39 && currentPage <= 39) {
      const questionIndex = currentPage - 39;
      const currentQuestion = MockData.data.WriteEssay[questionIndex];
      return (
        <WriteEssayMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("WriteEssay", questionIndex, answer)
          }
          questionNumber={questionIndex + 31}
        />
      );
    }
    if (currentPage >= 40 && currentPage <= 40) {
      const questionIndex = currentPage - 40;
      const currentQuestion = MockData.data.SingleAnswer[questionIndex];
      return (
        <MultipleTypeSingleMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("SingleAnswer", questionIndex, answer)
          }
          questionNumber={questionIndex + 1}
        />
      );
    }
    if (currentPage >= 41 && currentPage <= 41) {
      const questionIndex = currentPage - 41;
      const currentQuestion = MockData.data.DoubleAnswer[questionIndex];
      return (
        <MultipleTypeDoubleMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("DoubleAnswer", questionIndex, answer)
          }
          questionNumber={questionIndex + 2}
          maxQuestion={16}
        />
      );
    }
    if (currentPage >= 42 && currentPage <= 43) {
      const questionIndex = currentPage - 42;
      const currentQuestion = MockData.data.ReorderParagraph[questionIndex];
      return (
        <ReArrangeSentenceMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("ReorderParagraph", questionIndex, answer)
          }
          questionNumber={questionIndex + 3}
          maxQuestion={16}
        />
      );
    }
    if (currentPage >= 44 && currentPage <= 48) {
      const questionIndex = currentPage - 44;
      const currentQuestion = MockData.data.FillInTheBlank[questionIndex];
      return (
        <ReadingFillInTheBlanksMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("FillInTheBlank", questionIndex, answer)
          }
          questionNumber={questionIndex + 5}
          maxQuestion={16}
        />
      );
    }
    if (currentPage >= 49 && currentPage <= 53) {
      const questionIndex = currentPage - 49;
      const currentQuestion = MockData.data.ReadingandWriting[questionIndex];
      return (
        <FillInTheBlanksReadingAndWritingMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("ReadingandWriting", questionIndex, answer)
          }
          questionNumber={questionIndex + 10}
          maxQuestion={16}
        />
      );
    }
    if (currentPage >= 54 && currentPage <= 55) {
      const questionIndex = currentPage - 54;
      const currentQuestion = MockData.data.SummarizeSpokenText[questionIndex];
      return (
        <SummarizeSpokenTestMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("SummarizeSpokenText", questionIndex, answer)
          }
          questionNumber={questionIndex + 15}
          maxQuestion={16}
        />
      );
    }
    if (currentPage >= 56 && currentPage <= 56) {
      const questionIndex = currentPage - 56;
      const currentQuestion = MockData.data.McqSingleAnswer[questionIndex];
      return (
        <MCQSingleAnswerMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("McqSingleAnswer", questionIndex, answer)
          }
          questionNumber={questionIndex + 1}
          maxQuestion={11}
        />
      );
    }
    if (currentPage >= 57 && currentPage <= 57) {
      const questionIndex = currentPage - 57;
      const currentQuestion = MockData.data.McqDoubleAnswer[questionIndex];
      return (
        <MCQMultipleAnswerMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("McqDoubleAnswer", questionIndex, answer)
          }
          questionNumber={questionIndex + 2}
          maxQuestion={11}
        />
      );
    }
    if (currentPage >= 58 && currentPage <= 59) {
      const questionIndex = currentPage - 58;
      const currentQuestion = MockData.data.FillBlank[questionIndex];
      return (
        <FillInTheBlanksMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("FillBlank", questionIndex, answer)
          }
          questionNumber={questionIndex + 3}
          maxQuestion={11}
        />
      );
    }
    if (currentPage >= 60 && currentPage <= 60) {
      const questionIndex = currentPage - 60;
      const currentQuestion = MockData.data.HighlightSummary[questionIndex];
      return (
        <HighlightCorrectSummaryMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("HighlightSummary", questionIndex, answer)
          }
          questionNumber={questionIndex + 5}
          maxQuestion={11}
        />
      );
    }
    if (currentPage >= 61 && currentPage <= 61) {
      const questionIndex = currentPage - 61;
      const currentQuestion = MockData.data.MissingWord[questionIndex];
      return (
        <SelectMissingWordsMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("MissingWord", questionIndex, answer)
          }
          questionNumber={questionIndex + 6}
          maxQuestion={11}
        />
      );
    }
    if (currentPage >= 62 && currentPage <= 63) {
      const questionIndex = currentPage - 62;
      const currentQuestion = MockData.data.IncorrectWord[questionIndex];
      return (
        <HighlightIncorrectWordMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("IncorrectWord", questionIndex, answer)
          }
          questionNumber={questionIndex + 7}
          maxQuestion={11}
        />
      );
    }
    if (currentPage >= 64 && currentPage <= 66) {
      const questionIndex = currentPage - 64;
      const currentQuestion = MockData.data.WritefromDictation[questionIndex];
      return (
        <WriteFromDictationMockPage
          key={currentPage} // Adding key to force re-render
          question={currentQuestion}
          onInputChange={(answer) =>
            handleInputChange("WritefromDictation", questionIndex, answer)
          }
          questionNumber={questionIndex + 9}
          maxQuestion={11}
        />
      );
    }

    switch (currentPage) {
      case 1:
        return <HeadphoneCheckPage />;
      case 2:
        return <MicrophoneCheckPage />;
      case 3:
        return <KeyBoardCheckPage />;
      case 4:
        return <TestIntroductionPage />;
      case 5:
        return <SpeakingInstructionPage />;
      case 6:
        return <FullSectionPage />;
      case 7:
        return <SectionPage />;
      case 8:
        return (
          <PersonalIntroductionPage
            onInputChange={(answer) =>
              handleInputChange("PersonalIntroduction", answer)
            }
          />
        );

      // case 26:
      //   return <WriteFromDictationMockPage />;

      default:
        return null;
    }
  };

  return (
    <div>
      {renderPage()}
      {isLoading && <Loading />}
      {showConfirmDialog && (
        <ConfirmDialog
          message="Proceed to the next question?"
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}
      <div className="absolute top-16 font-bold p-2 pt-4 ml-[1255px] ">
        {" "}
        {currentPage >= 9 && (
          <Timer initialMinutes={146} initialSeconds={0} Text="Time Remaining" />
        )}
      </div>

      <MockNavigation
        onNext={handleNext}
        onPrevious={handlePrevious}
        disableNext={disableNext}
        disablePrevious={disablePrevious}
        currentPage={currentPage} // Pass currentPage here
        totalPages={totalPages} // Pass totalPages here
        handleSubmit={handleSubmit} // Pass handleSubmit here
      />

      {showNotification && (
        <Notification
          message={message}
          type={notificationType}
          onClose={handleCloseNotification}
        />
      )}
    </div>
  );
}
